import { createContext, useContext, type ReactNode } from 'react';

export const HostTrailingActionsContext = createContext<ReactNode>(null);

export const useHostTrailingActions = () =>
  useContext(HostTrailingActionsContext);
